var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 80,
    viewBox: "0 0 342 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_836_5083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 343,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    width: 80,
    height: 342.09,
    transform: "rotate(90 342 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_836_5083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.678 20.1148L261.678 -0.0458984L281.839 -0.0458976L281.839 20.1148L261.678 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.678 40.2755L261.678 20.1147L281.839 20.1147L281.839 40.2755L261.678 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.518 40.2755L241.518 20.1147L261.679 20.1147L261.679 40.2755L241.518 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.357 20.1148L221.357 -0.0458984L241.518 -0.0458976L241.518 20.1148L221.357 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.196 20.1148L201.196 -0.0458984L221.357 -0.0458976L221.357 20.1148L201.196 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.196 40.2755L201.196 20.1147L221.357 20.1147L221.357 40.2755L201.196 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.036 40.2755L181.036 20.1147L201.196 20.1147L201.196 40.2755L181.036 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.357 60.4366L221.357 40.2759L241.518 40.2759L241.518 60.4366L221.357 60.4366Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.875 20.1148L160.875 -0.0458984L181.035 -0.0458976L181.035 20.1148L160.875 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.714 20.1148L140.714 -0.0458984L160.875 -0.0458976L160.875 20.1148L140.714 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.714 40.2755L140.714 20.1147L160.875 20.1147L160.875 40.2755L140.714 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.553 40.2755L120.553 20.1147L140.714 20.1147L140.714 40.2755L120.553 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.875 60.4366L160.875 40.2759L181.035 40.2759L181.035 60.4366L160.875 60.4366Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.393 20.1148L100.393 -0.0458984L120.553 -0.0458976L120.553 20.1148L100.393 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2321 20.1148L80.2321 -0.0458984L100.393 -0.0458976L100.393 20.1148L80.2321 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2321 40.2755L80.2321 20.1147L100.393 20.1147L100.393 40.2755L80.2321 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0712 40.2755L60.0712 20.1147L80.232 20.1147L80.232 40.2755L60.0712 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.393 60.4366L100.393 40.2759L120.553 40.2759L120.553 60.4366L100.393 60.4366Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9104 20.1148L39.9104 -0.0458984L60.0711 -0.0458976L60.0711 20.1148L39.9104 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 20.1148L19.7497 -0.0458984L39.9105 -0.0458976L39.9105 20.1148L19.7497 20.1148Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 40.2755L19.7497 20.1147L39.9105 20.1147L39.9105 40.2755L19.7497 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.410981 40.2755L-0.41098 20.1147L19.7498 20.1147L19.7498 40.2755L-0.410981 40.2755Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9104 60.4366L39.9104 40.2759L60.0711 40.2759L60.0711 60.4366L39.9104 60.4366Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.679 60.4365L261.679 80.5973L281.839 80.5973L281.839 60.4365L261.679 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.357 60.4365L221.357 80.5973L241.518 80.5973L241.518 60.4365L221.357 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.036 60.4365L181.036 80.5973L201.196 80.5973L201.196 60.4365L181.036 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.714 60.4365L140.714 80.5973L160.875 80.5973L160.875 60.4365L140.714 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.393 60.4365L100.393 80.5973L120.553 80.5973L120.553 60.4365L100.393 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0712 60.4365L60.0712 80.5973L80.232 80.5973L80.232 60.4365L60.0712 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 60.4365L19.7497 80.5973L39.9105 80.5973L39.9105 60.4365L19.7497 60.4365Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.518 20.1148L241.518 -0.0458984L261.679 -0.0458976L261.679 20.1148L241.518 20.1148Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.679 60.4366L261.679 40.2759L281.839 40.2759L281.839 60.4366L261.679 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.518 60.4366L241.518 40.2759L261.679 40.2759L261.679 60.4366L241.518 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.357 40.2755L221.357 20.1147L241.518 20.1147L241.518 40.2755L221.357 40.2755Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.036 20.1148L181.036 -0.0458984L201.196 -0.0458976L201.196 20.1148L181.036 20.1148Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.196 60.4366L201.196 40.2759L221.357 40.2759L221.357 60.4366L201.196 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.036 60.4366L181.036 40.2759L201.196 40.2759L201.196 60.4366L181.036 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.875 40.2755L160.875 20.1147L181.035 20.1147L181.035 40.2755L160.875 40.2755Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.553 20.1148L120.553 -0.0458984L140.714 -0.0458976L140.714 20.1148L120.553 20.1148Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.714 60.4366L140.714 40.2759L160.875 40.2759L160.875 60.4366L140.714 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.553 60.4366L120.553 40.2759L140.714 40.2759L140.714 60.4366L120.553 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.393 40.2755L100.393 20.1147L120.553 20.1147L120.553 40.2755L100.393 40.2755Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0712 20.1148L60.0712 -0.0458984L80.2319 -0.0458976L80.2319 20.1148L60.0712 20.1148Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.232 60.4366L80.232 40.2759L100.393 40.2759L100.393 60.4366L80.232 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0712 60.4366L60.0712 40.2759L80.232 40.2759L80.232 60.4366L60.0712 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9104 40.2755L39.9104 20.1147L60.0711 20.1147L60.0711 40.2755L39.9104 40.2755Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.410981 20.1148L-0.41098 -0.0458984L19.7498 -0.0458976L19.7498 20.1148L-0.410981 20.1148Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 60.4366L19.7497 40.2759L39.9105 40.2759L39.9105 60.4366L19.7497 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.411012 60.4366L-0.411011 40.2759L19.7497 40.2759L19.7497 60.4366L-0.411012 60.4366Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.839 -0.0458984L281.839 20.1148L302 20.1148L302 -0.0458976L281.839 -0.0458984Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.839 40.2759L281.839 60.4366L302 60.4366L302 40.2759L281.839 40.2759Z",
    fill: "#0D058F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalPurple);
export default __webpack_public_path__ + "static/media/horizontalPurple.8b9c5f84d990919aa699d966afdf565a.svg";
export { ForwardRef as ReactComponent };